<template>
    <div><!-- 招標及報價查詢 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('SearchBar_Vue.CCardHeaderText')}}</strong>
            </CCardHeader>
            <CCardBody>                
                    <CForm>
                        <div class="CForminline">
                            <div class="quotation_class" v-if="!isMember" >
                                  <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                  <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                  <input type="radio" :name="'coa_FactoryTypeOpt'" v-model="searchParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                  </div> 
                            </div>
                            <div class="date_range">
                                <p>{{$t('SearchBar_Vue.StartDateBeginText')}}：</p>
                                <date-picker :lang="'zh-tw'" v-model="searchParam.StartDateBegin" format="YYYY-MM-DD" valueType="format" ></date-picker>
                                <span>~</span>
                                <date-picker :lang="'zh-tw'" v-model="searchParam.StartDateEnd" format="YYYY-MM-DD" valueType="format" :disabled-date="(date) => date <= new Date(searchParam.StartDateBegin)" ></date-picker>
                            </div>

                            <div class="date_range">
                                <p>{{$t('SearchBar_Vue.DeadlineBeginText')}}：</p>
                                <date-picker :lang="'zh-tw'" v-model="searchParam.DeadlineBegin" format="YYYY-MM-DD" valueType="format" ></date-picker>
                                <span>~</span>
                                <date-picker :lang="'zh-tw'" v-model="searchParam.DeadlineEnd" format="YYYY-MM-DD" valueType="format" :disabled-date="(date) => date <= new Date(searchParam.DeadlineBegin)" ></date-picker>
                            </div>

                            <div class="number_range">
                                <p>{{$t('SearchBar_Vue.QuoteNoIntervalText')}}：</p>
                                <input type="text" maxlength="12" v-model="searchParam.QuoteNoBegin" @change="checkQuoteNo">
                                <span>~</span>
                                <input type="text" maxlength="12" v-model="searchParam.QuoteNoEnd" @change="checkQuoteNo">
                            </div>

                            <div class="quotation_class">
                                <p>{{$t('SearchBar_Vue.RequestTypeText')}}：</p>
                                <div v-for="(item, key) in requestTypeList" :key="'requestType_input_' + key" >
                                    <input type="radio" name="requestType_input"
                                        v-model="searchParam.RequestType" 
                                        :value="item.requestTypeId" />{{item.requestTypeCaption}}
                                </div>
                            </div>

                            <div class="purchase">
                                <p>{{$t('SearchBar_Vue.PurchaserText')}}：</p>
                                <Select2 style="width: 30%" class="purchase_input" v-model="searchParam.PurchaserNo" :options="procurementOfficerList" :settings="{ 'multiple': 'true' }" />
                            </div>
                            <div class="closure">
                                <p>{{$t('SearchBar_Vue.CaseClosedText')}}：</p>
                                <div v-for="(item, key) in caseClosedList" :key="'caseClosed_input_' + key" >
                                    <input type="radio" name="caseClosed_input"
                                        v-model="searchParam.CaseClosed" 
                                        :value="item.caseClosedId" />{{item.caseClosedCaption}}
                                </div>
                            </div>

                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="searchDataEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="goAdd">{{$t('Buttons.AddNew')}}</button>
                                <button type="button" class="btn btn-dark mr-2" @click="exportReport">{{$t('Buttons.ExportOrder')}}</button>
                            </div>
                            
                        </div>
                    </CForm>                
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'

export default {
    data() {
        return {                    
            searchParam: {
                factoryId:'',
                StartDateBegin:'',
                StartDateEnd:'',
                DeadlineBegin:'',
                DeadlineEnd:'',
                QuoteNoBegin:'',
                QuoteNoEnd:'',
                RequestType:'',
                PurchaserNo:[],
                CaseClosed:''
            },
            requestTypeList: this.$t('requestSearchTypeList'), //報價類別 清單
            caseClosedList: this.$t('caseClosedList'), //結案否 清單
            factoryList: this.$t('factoryVNList') //廠別 清單
        }
    },
    props : {         
        finishInvalidCount : Number
    },
    watch: {
        finishInvalidCount: function(v) {
            if(v>0){
                this.searchData();
            }
        },
        lang: function() {            
            this.requestTypeList = this.$t('requestSearchTypeList')
            this.caseClosedList = this.$t('caseClosedList')
            this.factoryList = this.$t('factoryVNList') //廠別 清單
        }
    },
    mounted() {        
        this.getProcurementOfficers();
        const filter = this.$store.getters['purchaseModule/purchaseSearchObj'].filter; 
        if(filter){
            Object.assign(this.searchParam, filter);
        }
    },
    computed: {
        ...mapGetters('purchaseModule', ['procurementOfficerList']),
        ...mapGetters(['lang'])
    },
    methods: {
        ...mapActions('purchaseModule', ['searchPurchase','getProcurementOfficers']),        
        goAdd() {            
            sessionStorage.setItem('purchaseId', '');
            //this.$router.push({ path: '/purchaseadd' });
            this.$router.push({ path: '/purchaseedit' });
        },
        checkQuoteNo() {
            if(this.searchParam.QuoteNoBegin > this.searchParam.QuoteNoEnd) {
                this.searchParam.QuoteNoEnd = ''
            }
        },
        checkSearchParam(){ //檢核條件
           const {StartDateBegin,StartDateEnd,DeadlineBegin,DeadlineEnd,QuoteNoBegin,QuoteNoEnd} =this.searchParam;
           let errMsg = '';
           if(StartDateBegin && StartDateEnd){
               if(StartDateBegin>StartDateEnd){
                 errMsg='開單日期區間錯誤，起始日不得大於終止日!';
               }
           }
           if(DeadlineBegin && DeadlineEnd){
               if(DeadlineBegin>DeadlineEnd){
                 errMsg='截止日期區間錯誤，起始日不得大於終止日!';
               }
           }
           if(QuoteNoBegin && QuoteNoEnd){
               if(QuoteNoBegin>QuoteNoEnd){
                 errMsg='單號區間錯誤，起始單號不得大於終止單號!';
               }
           }
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        searchDataEvent(){//按鈕呼叫查詢觸發事件
            if(!this.checkSearchParam()){
                return;
            }
            if(!this.searchParam.QuoteNoEnd) {                
                this.searchParam.QuoteNoEnd = this.searchParam.QuoteNoBegin
            }
            this.$emit('doSearchEvent');
            this.searchData();
        },
        searchData() {
            //須用此方式提供 語系對應功能函數
            this.searchParam.func = (key) => this.$t(key);
            this.searchParam.fixDate = this.fixDate;
            this.searchPurchase(this.searchParam);            
        },
        exportReport () { //匯出
            if(!this.checkSearchParam()){
                return;
            }
            if(!this.searchParam.QuoteNoEnd) {                
                this.searchParam.QuoteNoEnd = this.searchParam.QuoteNoBegin
            }
            //--修正查詢參數中 StartDateBegin StartDateEnd  DeadlineBegin DeadlineEnd 若為空字串轉為 null
            let params = {}
            Object.assign(params , this.searchParam);
            const fixQry = ['StartDateBegin','StartDateEnd','DeadlineBegin','DeadlineEnd'];
            fixQry.forEach(it=>{
            if(params[it] === ''){
                params[it] = null;
            }
            });           
            const url = `${this.$apiUrl_Quotation}/PreparePurchaseSearchExport`;
            this.axios.post(url, params ).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quotation}/PurchaseSearchExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('purchaseSearchExportExcel',urlExcel);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .date_range, .number_range, .quotation_class, .purchase, .closure {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
        > div {
            margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
